import * as React from "react";
import EdButton from "../../../generic/edButton";
import DeviceContext from "../../../service/indentifyDevice";
import "../../../../assets/scss/components/toc/marginFiles/generic/marginFilter.scss";
import moment from "moment";

export interface IMarginFilterProps {
	data: Array<any>;
	expiryKey: string;
	onFilter: (filteredData: Array<any>, sDate: string) => void; // function to be called on clicking of checkbox, sDate = selected Date (value)
}

const MarginFilter: React.FC<IMarginFilterProps> = (props) => {
	//setting state initially as false
	const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

	/**
	 * state and function for selectedValue
	 * selectedValue type is number | string
	 * setSelectedValue(number | string)
	 */
	const [selectedValue, setSelectedValue] = React.useState("all");

	/**
	 * called when user selects an option
	 * @param id id of the selected option
	 * @returns onSelect prop passed from parent
	 */
	function optionSelected(id: string) {
		setSelectedValue(id);

		if (!DeviceContext().isMobile) {
			setIsDropdownOpen(false);

			if (id === "all") {
				// return the original data
				return props.onFilter(props.data, id);
			} else {
				// filter the data
				return props.onFilter(
					props.data.filter((d) => d[props.expiryKey] === id),
					id
				);
			}
		}
	}

	/**
	 * only called in mobile screen to reset the filter to all expiries
	 */
	function reset() {
		setSelectedValue("all");
		setIsDropdownOpen(false);
	}

	/**
	 * only called in mobile to close the filter popup
	 */
	function applyFilter() {
		setIsDropdownOpen(false);

		if (selectedValue === "all") {
			// return the original data
			return props.onFilter(props.data, selectedValue);
		} else {
			// filter the data
			return props.onFilter(props.data.filter((d) => d[props.expiryKey] === selectedValue), selectedValue);
		}
	}

	function dropdownOptions() {
		// find the unique expiries
		const unique = props.data.map((item) => item[props.expiryKey!]).filter((value, index, self) => self.indexOf(value) === index);

		// set value = expirykey and display = date
		return unique.map((d) => ({ display: moment(d).format("D MMM YYYY"), value: d }));
	}

	return (
		<div className={"margin_filter" + (selectedValue !== "all" ? " active" : "")}>
			<EdButton
				value={
					<>
						<i className="filter edel-icon-filter btn_icon" />
						{!DeviceContext().isMobile && <span className="fltr_lbl">Expiry</span>}
					</>
				}
				btnTyp="blue-link"
				onClick={() => setIsDropdownOpen(true)}
			/>

			{/* when dropdown is open show overlay and content */}
			{isDropdownOpen && (
				<div className="navigation_dropdown">
					{/* Overlay covers the whole screen. When overlay is clicked, close the dropdown. */}
					<div className="dropdown_overlay" onClick={() => setIsDropdownOpen(false)} />

					{/* Dropdown list */}
					<div className="dropdown_content">
						<ul>
							<li className={"dropdown_item" + ("all" === selectedValue ? " active" : "")} onClick={() => optionSelected("all")}>
								{/* show tick only if this option is selected */}
								<span className="tick_container">{"all" === selectedValue && <i className="tick edel-icon-tick" />}</span>
								<span>All Expiry</span>
							</li>
							{dropdownOptions().map((option) => (
								<li
									className={"dropdown_item" + (option.value === selectedValue ? " active" : "")}
									key={option.value}
									onClick={() => optionSelected(option.value as string)}
								>
									{/* show tick only if this option is selected */}
									<span className="tick_container">{option.value === selectedValue && <i className="tick edel-icon-tick" />}</span>
									<span>{option.display}</span>
								</li>
							))}
						</ul>
						{DeviceContext().isMobile && (
							<div className="fltr_btn">
								<EdButton value="Close" btnTyp="secondary" className="mob_fltr" onClick={() => reset()} />
								<EdButton value=" Apply Filter" btnTyp="primary" className="mob_fltr" onClick={applyFilter} />
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default MarginFilter;
